<template>
    <section class="bg--white m-0 position-relative no-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="main col-12">
                    <validation-observer ref="form">
                        <form action="" class="row">
                            <div class="form-section col-12 w-100">
                                <h2 class="heading-spacing--large pb-2">
                                    School
                                </h2>
                                <div class="row">
                                    <div
                                        v-if="profile.logo"
                                        class="col-12 col-md-6 order-md-12"
                                    >
                                        <div
                                            class="profile-logo justify-content-center align-items-center"
                                        >
                                            <img :src="profile.logo.src" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 order-md-1">
                                        <text-input
                                            v-model="profile.Name"
                                            class="col-12"
                                            name="Naam van school"
                                            rules="required"
                                            :disabled="true"
                                            @input="updateSchoolInformation"
                                        />
                                        <text-input
                                            v-model="profile.BRIN"
                                            class="col-12"
                                            name="BRIN"
                                            rules="required"
                                            @input="updateSchoolInformation"
                                        />
                                        <text-input
                                            v-model="profile.LocationNumber"
                                            class="col-12"
                                            name="Vestigingsnummer"
                                            rules="required"
                                            @input="updateSchoolInformation"
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </validation-observer>
                    <validation-observer ref="form">
                        <form action="" class="row">
                            <div class="form-section col-12 w-100">
                                <h2 class="heading-spacing--medium pb-2">
                                    Groepen
                                </h2>
                                <div>
                                    <div
                                        v-for="(group,
                                        groupIndex) in profile.Groups"
                                        id="group-row"
                                        :key="groupIndex"
                                        class="row row--single teacher-row group-row"
                                        :class="'item-' + groupIndex"
                                    >
                                        <text-input
                                            v-model="group.Name"
                                            name="Groepnaam"
                                            rules="required"
                                            class="col-10 col-sm-6"
                                            placeholder="Groepnaam"
                                        />
                                        <div class="col-2 trash-container">
                                            <button
                                                v-if="!processing"
                                                class="btn-trash"
                                                @click.prevent="
                                                    {
                                                        (currentGroupToDelete = groupIndex),
                                                            (dialogGroup = true);
                                                    }
                                                "
                                            >
                                                <span>
                                                    <i
                                                        class="fas fa-trash-alt"
                                                    ></i>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="col-12 d-flex justify-content-md-right align-items-right mt-2"
                                >
                                    <button
                                        class="btn pl-4 btn--purple-1"
                                        :disabled="processing"
                                        @click.prevent="addGroupComponent"
                                    >
                                        <span>
                                            Voeg groep toe
                                            <i class="fas fa-plus ml-2"></i>
                                        </span>
                                    </button>

                                    <button
                                        class="btn pl-4 btn--green-1 ml-2"
                                        :disabled="processing"
                                        @click.prevent="updateSchoolInformation"
                                    >
                                        <span>
                                            Groepen opslaan
                                            <i
                                                v-if="groupsAreSaved"
                                                class="fas fa-check ml-2"
                                            ></i>
                                        </span>
                                    </button>
                                </div>
                                <p v-if="showGroupInUse" class="input-error">
                                    Deze groep heeft nog leraren die eraan
                                    gekoppeld zijn
                                </p>
                            </div>
                            <div data-app>
                                <v-dialog
                                    v-model="dialogGroup"
                                    transition="dialog-bottom-transition"
                                    max-width="600"
                                >
                                    <v-card>
                                        <v-card-title
                                            class="headline grey lighten-2"
                                        >
                                            Weet je het zeker?
                                        </v-card-title>

                                        <v-card-text>
                                            Weet je zeker dat je deze groep wilt
                                            verwijderen?
                                        </v-card-text>

                                        <v-divider></v-divider>

                                        <v-card-actions>
                                            <button
                                                class="btn btn--small col-md-5 btn--green-1"
                                                @click.prevent="
                                                    removeGroupComponent(
                                                        currentGroupToDelete
                                                    ),
                                                        (dialogGroup = false)
                                                "
                                            >
                                                <span>Verwijderen</span>
                                            </button>
                                            <button
                                                class="btn col-md-5 offset-md-1 btn--small btn--culture"
                                                text
                                                @click.prevent="
                                                    dialogGroup = false
                                                "
                                            >
                                                <span>Nee, annuleren</span>
                                            </button>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </form>
                    </validation-observer>
                    <validation-observer ref="form">
                        <form action="" class="row">
                            <div
                                class="form-section col-12 form-section--compact w-100"
                            >
                                <h2 class="heading-spacing--medium pb-2">
                                    Leerkrachten accounts
                                </h2>
                                <div
                                    v-if="
                                        profile.Teachers != null &&
                                            profile.Teachers.length > 0
                                    "
                                >
                                    <div
                                        class="row teacher-row teacher-row--overview row--single label-container"
                                    >
                                        <div class="col-4 col-md-2">
                                            <label>Voornaam</label>
                                        </div>
                                        <div class="col-4 col-md-2">
                                            <label>Tussenvoegsel</label>
                                        </div>
                                        <div class="col-4 col-md-2">
                                            <label>Achternaam</label>
                                        </div>
                                        <div class="col-12 col-sm-6 col-md-3">
                                            <label>E-mailadres</label>
                                        </div>
                                        <div class="col-10 col-sm-4 col-md-2">
                                            <label>Groep</label>
                                        </div>
                                    </div>
                                    <div
                                        v-for="(teacher,
                                        teacherIndex) in profile.Teachers"
                                        id="teacher-row"
                                        :key="teacherIndex"
                                        class="row teacher-row"
                                    >
                                        <template v-if="!teacher.Removed">
                                            <text-input
                                                v-model="teacher.Firstname"
                                                class="col-4 col-md-2"
                                                name="Voornaam"
                                                rules="required"
                                            />
                                            <text-input
                                                v-model="teacher.Insertion"
                                                class="col-4 col-md-2"
                                                name="Tussenvoegsel"
                                            />
                                            <text-input
                                                v-model="teacher.Lastname"
                                                class="col-4 col-md-2"
                                                name="Achternaam"
                                                rules="required"
                                            />
                                            <text-input
                                                v-model="teacher.Email"
                                                class="col-12 col-sm-6 col-md-3"
                                                name="E-mail leerkracht"
                                                rules="required|email"
                                            />
                                            <div
                                                v-if="
                                                    profile.Groups &&
                                                        !teacher.Removed
                                                "
                                                class="col-10 col-sm-4 col-md-2"
                                            >
                                                <label
                                                    for=""
                                                    class="label--default label--select"
                                                    >Groep</label
                                                >
                                                <div
                                                    class="select--wrapper select--wrapper-default"
                                                >
                                                    <select
                                                        v-model="
                                                            teacher.Groups[0]
                                                        "
                                                        :disabled="submitted"
                                                        class="input--default input--rounded select--small"
                                                        type="text"
                                                        placeholder="Groep"
                                                        name="Groep"
                                                    >
                                                        <option value="">
                                                            Selecteer groep
                                                        </option>
                                                        <option
                                                            v-for="group in profile.Groups"
                                                            :key="group.Name"
                                                            :disabled="
                                                                (group.Removed,
                                                                submitted)
                                                            "
                                                            :value="group"
                                                        >
                                                            {{ group.Name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div
                                                class="col-2 col-md-1 trash-container"
                                            >
                                                <button
                                                    class="btn-trash"
                                                    @click.prevent="
                                                        {
                                                            (currentTeacherToDelete = teacherIndex),
                                                                (dialogTeacher = true);
                                                        }
                                                    "
                                                >
                                                    <span>
                                                        <i
                                                            class="fas fa-trash-alt"
                                                        ></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </template>
                                    </div>
                                    <p
                                        v-if="showGroupsError"
                                        class="input-error"
                                    >
                                        Helaas, er ging iets mis met opslaan.
                                        Zijn alle velden wel correct ingevuld?
                                    </p>
                                </div>
                                <div v-else>
                                    Er dienen eerst groepen te worden aangemaakt
                                    voordat er leerkrachten accounts aangemaakt
                                    kunnen worden.
                                </div>

                                <div
                                    v-if="profile.Groups.length > 0"
                                    class="col-12 d-flex flex-row-reverse mt-2"
                                >
                                    <button
                                        class="btn pl-4 btn--green-1 ml-2"
                                        @click.prevent="updateSchoolInformation"
                                    >
                                        <span>
                                            Leerkrachten opslaan
                                            <i
                                                v-if="responseMsg !== ''"
                                                class="fas fa-check ml-2"
                                            ></i>
                                        </span>
                                    </button>

                                    <button
                                        class="btn pl-4 btn--purple-1"
                                        @click.prevent="addTeacherComponent"
                                    >
                                        <span>
                                            Voeg leerkracht toe
                                            <i class="fas fa-plus ml-2"></i>
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div data-app>
                                <v-dialog
                                    v-model="dialogTeacher"
                                    transition="dialog-bottom-transition"
                                    max-width="600"
                                >
                                    <v-card>
                                        <v-card-title
                                            class="headline grey lighten-2"
                                        >
                                            Weet je het zeker?
                                        </v-card-title>

                                        <v-card-text>
                                            Weet je zeker dat je deze leerkracht
                                            wil verwijderen?
                                        </v-card-text>

                                        <v-divider></v-divider>

                                        <v-card-actions>
                                            <button
                                                class="btn btn--small col-md-5 btn--green-1"
                                                @click.prevent="
                                                    removeTeacherComponent(
                                                        currentTeacherToDelete
                                                    ),
                                                        (dialogTeacher = false)
                                                "
                                            >
                                                <span>Verwijderen</span>
                                            </button>
                                            <button
                                                class="btn col-md-5 offset-md-1 btn--small btn--culture"
                                                text
                                                @click.prevent="
                                                    dialogTeacher = false
                                                "
                                            >
                                                <span>Nee, annuleren</span>
                                            </button>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </form>
                    </validation-observer>
                    <validation-observer ref="form">
                        <form action="" class="row">
                            <div class="form-section col-12 col-md-6 w-100">
                                <h2 class="heading-spacing--medium pb-2">
                                    Adresgegevens school
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="profile.Street"
                                        class="col-12"
                                        name="Straatnaam"
                                        :value="profile.Street"
                                        rules="required"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.Housenumber"
                                        class="col-6"
                                        name="Huisnummer"
                                        type="number"
                                        :value="profile.Housenumber"
                                        rules="required"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.HousenumberAddition"
                                        class="col-6"
                                        name="Toevoeging"
                                        :value="profile.HousenumberAddition"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.Zipcode"
                                        class="col-12"
                                        name="Postcode"
                                        :value="profile.Zipcode"
                                        rules="required"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.City"
                                        class="col-12 col-md-6"
                                        name="Plaats"
                                        :value="profile.City"
                                        rules="required"
                                        @input="updateSchoolInformation"
                                    />

                                    <text-input
                                        v-model="profile.Municipality"
                                        class="col-12 col-md-6"
                                        name="Gemeente"
                                        :value="profile.Municipality"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.phone"
                                        class="col-12 col-md-12"
                                        name="Telefoonnummer"
                                        :value="profile.phone"
                                        @input="updateSchoolInformation"
                                    />
                                </div>
                            </div>

                            <editPassword
                                :profile="profile"
                                class="col-12 col-md-6 login-small"
                                @input="updateSchoolInformation"
                            />

                            <div class="form-section col-12 w-100">
                                <h2 class="heading-spacing--medium pb-2">
                                    Contactpersoon
                                </h2>
                                <div class="row">
                                    <text-input
                                        v-model="profile.ContactPersonFirstname"
                                        class="col-12 col-md-4"
                                        name="Voornaam"
                                        rules="required"
                                        :value="profile.ContactPersonFirstname"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.ContactPersonInsertion"
                                        class="col-6 col-md-3"
                                        name="Tussenvoegsel"
                                        :value="profile.ContactPersonInsertion"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.ContactPersonLastname"
                                        rules="required"
                                        class="col-6 col-md-4"
                                        name="Achternaam"
                                        :value="profile.ContactPersonLastname"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.ContactPersonPhone"
                                        rules="required|digits:10"
                                        class="col-12 col-md-4"
                                        name="Telefoonnummer"
                                        :value="profile.ContactPersonPhone"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.ContactPersonEmail"
                                        class="col-12 col-md-7"
                                        rules="required|email"
                                        name="E-mailadres"
                                        :value="profile.ContactPersonEmail"
                                        @input="updateSchoolInformation"
                                    />
                                    <text-input
                                        v-model="profile.ContactPersonRole"
                                        class="col-12 col-md-4"
                                        name="Functie"
                                        :value="profile.ContactPersonRole"
                                        @input="updateSchoolInformation"
                                    />
                                </div>
                            </div>
                            <dashboardMessage
                                :message="responseMsg"
                                :process="processing"
                            />
                        </form>
                    </validation-observer>
                </div>
            </div>
        </div>
        <error-bar v-if="errorMessage" :error-message="errorMessage" />
    </section>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import { initVeeValidate } from '@/plugins/vee-validate';
import textInput from '@/components/form/text-input';
import editPassword from '@/components/form/edit-password';
import errorBar from '@/components/clientdashboard/dashboard-profile/error-bar';
import dashboardMessage from '@/components/clientdashboard/dashboard-profile/clientdashboard-profile-message';
import Axios from 'axios';

initVeeValidate();

export default {
    components: {
        ValidationObserver,
        textInput,
        editPassword,
        errorBar,
        dashboardMessage
    },
    props: {
        originalProfile: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            currentGroupToDelete: 0,
            currentTeacherToDelete: 0,
            responseMsg: '',
            errorMessage: '',
            showGroupInUse: false,
            groupsAreSaved: false,
            showGroupsError: false,
            validationError: false,
            success: false,
            submitted: false,
            toggle: false,
            dialogGroup: false,
            dialogTeacher: false,
            elementVisible: false,
            profile: {
                Id: '',
                Name: '',
                Brin: '',
                LocationNumber: '',
                SchoolLogo: '',
                Street: '',
                Housenumber: '',
                HousenumberAddition: '',
                Zipcode: '',
                City: '',
                Phone: '',
                Email: '',
                Password: '',
                PasswordRepeat: '',
                ContactPersonFirstname: '',
                ContactPersonInsertion: '',
                ContactPersonLastname: '',
                ContactPersonPhone: '',
                ContactPersonEmail: '',
                ContactPersonRole: '',
                Groups: [],
                Teachers: []
            },
            processing: false
        };
    },
    mounted() {
        this.profile = this.originalProfile;
    },
    methods: {
        updateSchoolInformation() {
            this.submitted = true;
            this.processing = true;
            this.responseMsg = '';
            const self = this;
            this.$refs.form.validate().then(success => {
                if (success) {
                    Axios.post('/clientdashboard/school/update', self.profile)
                        .then(response => {
                            self.response = response;
                            self.submitted = false;
                            self.responseMsg = response.data.SuccessMsg;
                            self.profile.Password = null;
                            self.profile.PasswordRepeat = null;

                            setTimeout(function() {
                                self.responseMsg = '';
                            }, 5000);
                        })
                        .catch(error => {
                            self.errorMessage =
                                error.response.data.ExceptionMessage;
                            setTimeout(function() {
                                self.errorMessage = '';
                            }, 5000);
                        })
                        .finally(() => {
                            self.processing = false;
                        });
                } else {
                    self.processing = false;
                    self.errorMessage =
                        'Controleer jouw invoer, mogelijk zijn er verplichte velden niet ingevuld of zijn er velden niet correct ingevuld.';
                    setTimeout(function() {
                        self.errorMessage = '';
                    }, 3500);
                }
            });
        },
        addTeacherComponent() {
            if (this.profile.Teachers == null) {
                this.profile.Teachers = [];
            }

            this.profile.Teachers.push({
                FirstName: '',
                Insertion: '',
                LastName: '',
                Email: '',
                Groups: [],
                Removed: false,
                ReadOnly: false
            });
            this.$refs.form.validate();
            return;
        },
        removeTeacherComponent(index) {
            this.profile.Teachers[index].Removed = true;
            this.updateSchoolInformation();
            return;
        },
        addGroupComponent() {
            if (this.profile.Groups == null) {
                this.profile.Groups = [];
            }

            this.profile.Groups.push({
                Name: '',
                Removed: false,
                ReadOnly: false
            });
            this.$refs.form.validate();
            return;
        },
        removeGroupComponent(index) {
            this.showGroupInUse = false;
            const foundItem = this.profile.Groups[index];
            const self = this;
            for (let index = 0; index < this.profile.Teachers.length; index++) {
                const element = this.profile.Teachers[index];
                if (element.Groups.find(x => x.Id == foundItem.Id)) {
                    this.showGroupInUse = true;
                    setTimeout(function() {
                        self.showGroupInUse = false;
                    }, 2000);
                    return;
                }
            }

            foundItem.Removed = true;
            this.profile.Groups.splice(index, 1);
            this.updateSchoolInformation();
            this.groupsAreSaved = true;
            setTimeout(function() {
                self.groupsAreSaved = false;
            }, 2000);
        }
    }
};
</script>
<style lang="scss">
.teacher-row {
    background-color: #fbfbfb;
    padding: 10px;
    border-radius: 4px;
    position: relative;

    &:not(.row--single) {
        margin-bottom: 20px;
    }

    .btn-trash {
        visibility: visible;
        background-color: #fbfbfb;
        border-radius: 50%;
        width: 58px;
        height: 58px;
        line-height: 36px;
        border: 2px #e7e7e7 solid;
        color: #616161;

        &:hover {
            color: #64338a;
        }
    }

    &.group-row.row--single {
        .input__label {
            .row & {
                display: none;
            }
        }
    }

    .input__label,
    .label--select {
        .form-section & {
            .row & {
                font-size: 0.8rem;
                display: inline-block;
            }
        }
    }

    .label--select {
        margin-top: 0;
    }

    .select--small {
        line-height: 2rem;
        padding-right: 34px;
    }
    select [disabled] {
        display: none;
    }
    .select--wrapper::after {
        top: 12px;
    }
}

.message--top,
.confirmation {
    background-color: rgba(255, 255, 255, 0.7);
    border: 1px solid lightgray;
}

.message--aproved {
    max-width: max-content !important;
    background: rgb(181 181 181 / 20%);
    border: 2px solid #058e05;
    border-radius: 3px;

    .fas {
        color: #058e05;
    }
}

.confirmation {
    position: absolute;
    width: 72vw;
    text-align: center;
    top: 0;
    padding: 10px;
    border-radius: 5px;
    z-index: 1;
    box-shadow: 0px 0px 8px -3px #00000094;
}

.row--single {
    display: inline;
}
.row--single {
    margin-bottom: 0;
}
.teacher-row {
    &.label-container {
        display: none;
    }
    &:first-child {
        .trash-container {
            flex-direction: column-reverse;
        }
    }
}
.trash-container {
    display: flex;

    .row--single & {
        > div {
            margin-top: 2px;
            height: 58px;
        }
    }
}

#teacher-row:hover .btn-trash {
    visibility: visible;
}
@media screen and (min-width: 768px) {
    .teacher-row {
        .input__label,
        .label--select {
            font-size: 0.9rem;
        }
        .input__label,
        .label--select {
            display: inline-block;
        }
        &.row--single .input__label {
            display: inline-block;
        }
    }
}

@media screen and (min-width: 1024px) {
    .teacher-row {
        padding: 0;
        &.label-container {
            display: flex;
        }
        &:not(.row--single) {
            margin-bottom: 10px;
        }
        .input__label,
        .label--select {
            display: none !important;
            font-size: 1rem;
        }
    }
}
</style>
